<template>
  <div id="app">

    <vue-progress-bar></vue-progress-bar>

    <div v-if='screenSize.mobile'
         class='top-block'></div>

    <div @click='toggleLogo'
         :class='{"hidden": logoHidden}'
         id='pop-up'>
      <img src='./assets/logo.png'>
    </div>

    <transition name="fade">
      <dsSideBar :screen-size='screenSize'
                 :posts='posts'
                 :overons='overonsPost'
                 :loaded='loaded'
                 :location='location'
                 :language='language'>
      </dsSideBar>
    </transition>

    <div id='container'>

      <!-- // HEADER -->
      <transition name="fade">
        <dsHeader :screen-size='screenSize'
                  :quotes='quotes'
                  :loaded='loaded'
                  :language='language'>
        </dsHeader>
      </transition>

      <!-- // MAIN -->
      <transition name="fade">
        <main id='main'
              class='full-width float-left margin-right'>
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->

          <!-- // OVERONS: HEADER TEXT -->
          <div class='main-column'>
            <div v-if='location.overons && loaded.overons'
                 class='single-content float-left one-column-fixed-height border-bottom padding-bottom padding-top'>
              <span v-if='language === "nl" && loaded.posts'
                    v-html='overonsPost.acf.header'></span>
              <span v-if='language === "en" && loaded.posts'
                    v-html='overonsPost.acf.header_en'></span>
            </div>

            <!-- // OVERONS: ONE COLUMN TEXT -->

            <div v-if='language === "nl" && location.overons && loaded.overons'
                 v-html='overonsPost.content.rendered'
                 class='single-content main-column padding-top'></div>
            <div v-if='language === "en" && location.overons && loaded.overons'
                 v-html='overonsPost.acf.main_text_en'
                 class='single-content main-column padding-top'></div>
          </div>

          <aside v-if='location.overons && loaded.overons'
                 class='secondary-column float-left'>
            <div class='team-container border-bottom margin-bottom'>
              <div v-if='language === "nl"'
                   class='padding-top margin-bottom center'>
                <span class='border-bottom strong'>Wie zijn wij?</span>
              </div>
              <div v-if='language === "en"'
                   class='padding-top margin-bottom center'>
                <span class='border-bottom strong'>Who are we?</span>
              </div>
              <dsTeamItem v-for='item in overonsPost.acf["wie_zijn_wij"]'
                          :item="item"
                          :language='language'></dsTeamItem>
            </div>
            <div v-if='language === "nl"'
                 class='center margin-bottom'>
              <span class='border-bottom strong'>Pers</span>
            </div>
            <div v-if='language === "en"'
                 class='center margin-bottom'>
              <span class='border-bottom strong'>Press</span>
            </div>
            <a v-for='item in overonsPost.acf.press'
               :key='item.link'
               :href='item.link'
               target=_blank
               class='press secondary-color strong margin-bottom'
               v-html='item.text'></a>
          </aside>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // SINGLE: ONE COLUMN TEXT -->
          <div v-if='location.single && loaded.posts'
               class='single-content main-column padding-top'>

            <div v-if='specialCategory'>
              <router-link :to="{name: specialCategory.slug, params: {language: language}}"
                           class='strong no-underline'>
                <span v-if='language === "nl"'>&#60; {{specialCategory.name}}</span>
                <span v-if='language === "en"'>&#60; {{specialCategory.name}}</span>
              </router-link>
            </div>

            <!-- // MAIN TEXT: ARTICLE -->
            <span v-if='language === "nl"'
                  v-html='posts.single.acf.main_text'></span>
            <span v-if='language === "en"'
                  v-html='posts.single.acf.main_text_en'></span>

            <!-- // TAGS: ARTICLE -->
            <p v-if='screenSize.mobile === false'
               id='tags'
               class="secondary-color large-text uppercase margin-bottom light">
              <span class='italic'>TAGS</span>
              <dsTagItemInline v-for='tag in posts.single.tags'
                               :tag="tag"
                               :tags='tagCollection'
                               :language='language'></dsTagItemInline>
            </p>

            <!-- // SHARE LINKS: ARTICLE -->
            <p v-if='language === "nl"'
               class='large-text secondary-color light'>
              <span class='high-light'>DELEN</span>
              <span>op
                <a href=''
                   class='share-to-fb'>Facebook</a>
              </span>
            </p>

            <p v-if='language === "en"'
               class='large-text secondary-color light'>
              <span class='high-light'>SHARE</span>
              <span>on
                <a href=''
                   class='share-to-fb'>Facebook</a>
              </span>
            </p>

          </div>

          <!-- // SINGLE: TAGS -->
          <aside v-if='location.single && loaded.posts'
                 class='secondary-column float-left'>
            <dsTags v-if='loaded.tags'
                    class='aside-tags border-bottom margin-bottom'
                    tags='tagCollection'
                    :language='language'
                    :tags='tags'>
            </dsTags>
            <!-- // ARTICLE: RELATED POSTS -->
            <div v-if='language === "nl"'
                 class='center margin-bottom'>
              <span class='border-bottom strong'>Lees ook</span>
            </div>
            <div v-if='language === "en"'
                 class='center margin-bottom'>
              <span class='border-bottom strong'>Related posts</span>
            </div>
            <dsGridItem v-for='item in relatedPosts'
                        :item="item"
                        :language="language"
                        :tags='tagCollection'
                        :location='location'
                        :screen-size='screenSize'></dsGridItem>
          </aside>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // VERDIEPING: INTRO SECTION -->
          <dsSectionIntro v-if='location.verdieping && loaded.posts && loaded.pages'
                          :language='language'
                          :loaded='loaded'
                          :location='location'
                          :screen-size='screenSize'
                          :introNL='intro.verdieping.content.rendered'
                          :introEN='intro.verdieping.acf.main_text_en'
                          :tags='tags'>
          </dsSectionIntro>
          <!-- // VERDIEPING: GRID -->
          <dsGrid v-if='location.verdieping && loaded.posts && loaded.pages'
                  :tags='tagCollection'
                  :location='location'
                  :screen-size='screenSize'
                  :posts='posts.verdieping'
                  :language='language'>
          </dsGrid>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // HOME: FEATURED -->
          <dsFeatured v-if='location.home && loaded.posts && loaded.tags'
                      :posts='posts'
                      :screen-size='screenSize'
                      :tags='tagCollection'
                      :language='language'>
          </dsFeatured>

          <!-- // HOME: GRID -->
          <dsGrid v-if='location.home && loaded.posts && loaded.tags'
                  :screen-size='screenSize'
                  :posts='posts.first'
                  :location='location'
                  :tags='tagCollection'
                  :language='language'>
          </dsGrid>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // MEEDOEN: HEADER TEXT -->
          <div v-if='location.meedoen && loaded.meedoen'
               class='single-content main-column float-left one-column-fixed-height border-bottom padding-bottom padding-top'>
            <span v-if='language === "nl" && loaded.posts'
                  v-html='meedoenPost.acf.header'></span>
            <span v-if='language === "en" && loaded.posts'
                  v-html='meedoenPost.acf.header_en'></span>
          </div>
          <!-- // MEEDOEN: TAGS -->
          <aside v-if='location.meedoen && loaded.meedoen'
                 class='secondary-column float-left'>
            <dsTags v-if='loaded.tags'
                    :language='language'
                    class='aside-tags border-bottom margin-bottom'
                    :tags='tags'>
            </dsTags>
          </aside>
          <!-- // MEEDOEN: ONE COLUMN TEXT -->
          <!-- <div v-if='language === "nl" && location.meedoen && loaded.meedoen' v-html='meedoenPost.content.rendered' class='single-content main-column padding-top'></div> -->
          <!-- <div v-if='language === "en" && location.meedoen && loaded.meedoen' v-html='meedoenPost.acf.main_text_en' class='single-content main-column padding-top'></div> -->

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // NIEUWS: INTRO SECTION-->
          <dsSectionIntro v-if='location.nieuws && loaded.pages'
                          :language='language'
                          :loaded='loaded'
                          :location='location'
                          :screen-size='screenSize'
                          :introNL='intro.nieuws.content.rendered'
                          :introEN='intro.nieuws.acf.main_text_en'
                          :tags='tags'>
          </dsSectionIntro>
          <!-- // NIEUWS: GRID -->
          <dsGrid v-if='location.nieuws && loaded.posts && loaded.tags'
                  :screen-size='screenSize'
                  :posts='posts.nieuws'
                  :tags='tagCollection'
                  :location='location'
                  :language='language'>
          </dsGrid>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // PROGRAMMA: INTRO TEXT -->
          <dsSectionIntro v-if='location.programma && loaded.pages'
                          :language='language'
                          :loaded='loaded'
                          :location='location'
                          :screen-size='screenSize'
                          :filters='filters'
                          :introNL='intro.programma.content.rendered'
                          :introEN='intro.programma.acf.main_text_en'
                          :tags='tags'>
          </dsSectionIntro>
          <!-- //PROGRAMMA: GRID -->
          <dsGrid v-if='location.programma && loaded.posts && loaded.tags'
                  :screen-size='screenSize'
                  :posts='posts.programma'
                  :filters='filters'
                  :location='location'
                  :tags='tagCollection'
                  :language='language'>
          </dsGrid>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // SEARCH: GRID -->
          <dsGrid v-if='location.zoek && loaded.search'
                  :screen-size='screenSize'
                  :posts='posts.search'
                  :location='location'
                  :search='currentSearchTerm'
                  :tags='tagCollection'
                  :language='language'>
          </dsGrid>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // TAGS: GRID -->
          <dsGrid v-if='location.tag && loaded.tagSearch'
                  :screen-size='screenSize'
                  :posts='posts.tag'
                  :location='location'
                  :tag='currentTag'
                  :tags='tagCollection'
                  :language='language'>
          </dsGrid>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // VERDIEPING ARCHIEF: INTRO TEXT -->
          <dsSectionIntro v-if='location["verdieping-archief"] && loaded.pages'
                          :language='language'
                          :loaded='loaded'
                          :location='location'
                          :screen-size='screenSize'
                          :introNL='intro.verdiepingArchief.content.rendered'
                          :introEN='intro.verdiepingArchief.acf.main_text_en'
                          :tags='tags'>
          </dsSectionIntro>
          <!-- // VERDIEPING ARCHIEF: GRID -->
          <dsGrid v-if='location["verdieping-archief"] && loaded.posts && loaded.tags'
                  :screen-size='screenSize'
                  :posts='posts.archief'
                  :location='location'
                  :tags='tagCollection'
                  :language='language'>
          </dsGrid>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // VERDIEPING PROGRAMMA: INTRO TEXT -->
          <dsSectionIntro v-if='location["verdieping-programma"] && loaded.pages'
                          :language='language'
                          :loaded='loaded'
                          :location='location'
                          :screen-size='screenSize'
                          :introNL='intro.verdiepingProgramma.content.rendered'
                          :introEN='intro.verdiepingProgramma.acf.main_text_en'
                          :tags='tags'>
          </dsSectionIntro>
          <!-- // VERDIEPING PROGRAMMA: ONE COLUMN -->
          <div v-if='language === "nl" && location["verdieping-programma"] && loaded.pages'
               v-html='intro.verdiepingProgramma.acf.full_text'
               class='single-content main-column padding-top'></div>
          <div v-if='language === "en" && location["verdieping-programma"] && loaded.pages'
               v-html='intro.verdiepingProgramma.acf.full_text_en'
               class='single-content main-column padding-top'></div>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // VERDIEPING ESSAYS: INTRO TEXT -->
          <dsSectionIntro v-if='location["verdieping-essays"] && loaded.pages'
                          :language='language'
                          :loaded='loaded'
                          :location='location'
                          :screen-size='screenSize'
                          :introNL='intro.verdiepingEssays.content.rendered'
                          :introEN='intro.verdiepingEssays.acf.main_text_en'
                          :tags='tags'>
          </dsSectionIntro>
          <!-- // VERDIEPING ESSAYS: GRID -->
          <dsGrid v-if='location["verdieping-essays"] && loaded.posts && loaded.tags'
                  :screen-size='screenSize'
                  :posts='posts.essays'
                  :location='location'
                  :tags='tagCollection'
                  :language='language'>
          </dsGrid>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // VERDIEPING MAPPING: INTRO TEXT -->
          <dsSectionIntro v-if='location["verdieping-mapping"]'
                          :language='language'
                          :loaded='loaded'
                          :location='location'
                          :screen-size='screenSize'
                          :introNL='intro.verdiepingMapping.content.rendered'
                          :introEN='intro.verdiepingMapping.acf.main_text_en'
                          :tags='tags'>
          </dsSectionIntro>
          <!-- // VERDIEPING MAPPING: ONE COLUMN -->
          <div v-if='language === "nl" && location["verdieping-mapping"] && loaded.pages'
               v-html='intro.verdiepingMapping.acf.full_text'
               class='single-content main-column padding-top'></div>
          <div v-if='language === "en" && location["verdieping-mapping"] && loaded.pages'
               v-html='intro.verdiepingMapping.acf.full_text_en'
               class='single-content main-column padding-top'></div>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // VERDIEPING LINKS NAAR MEER: INTRO TEXT -->
          <dsSectionIntro v-if='location["verdieping-links-naar-meer"] && loaded.pages'
                          :language='language'
                          :loaded='loaded'
                          :location='location'
                          :screen-size='screenSize'
                          :introNL='intro.verdiepingLinksNaarMeer.content.rendered'
                          :introEN='intro.verdiepingLinksNaarMeer.acf.main_text_en'
                          :tags='tags'>
          </dsSectionIntro>
          <!-- // VERDIEPING LINKS NAAR MEER: ONE COLUMN -->
          <div v-if='language === "nl" && location["verdieping-links-naar-meer"] && loaded.pages'
               v-html='intro.verdiepingLinksNaarMeer.acf.full_text'
               class='single-content main-column padding-top'></div>
          <div v-if='language === "en" && location["verdieping-links-naar-meer"] && loaded.pages'
               v-html='intro.verdiepingLinksNaarMeer.acf.full_text_en'
               class='single-content main-column padding-top'></div>

          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // ********* // -->
          <!-- // VERDIEPING KLANKSBORDGROEP: INTRO TEXT -->
          <dsSectionIntro v-if='location["verdieping-klankbordgroep"] && loaded.pages'
                          :language='language'
                          :loaded='loaded'
                          :location='location'
                          :screen-size='screenSize'
                          :introNL='intro.verdiepingKlankbordgroep.content.rendered'
                          :introEN='intro.verdiepingKlankbordgroep.acf.main_text_en'
                          :tags='tags'>
          </dsSectionIntro>
          <!-- // VERDIEPING KLANKSBORDGROEP: GRID -->
          <dsGrid v-if='location["verdieping-klankbordgroep"] && loaded.posts && loaded.tags'
                  :screen-size='screenSize'
                  :posts='posts.klankbordgroep'
                  :location='location'
                  :tags='tagCollection'
                  :language='language'>
          </dsGrid>

        </main>
      </transition>

      <!-- // FOOTER -->
      <transition name="fade">
        <dsFooter v-if='loaded.posts'
                  :screen-size='screenSize'
                  :location='location'
                  :language='language'>
        </dsFooter>
      </transition>

    </div>
  </div>
</template>

<script>
import dsSideBar from './components/dsSideBar'
import dsHeader from './components/dsHeader'
import dsFeatured from './components/dsFeatured'
import dsGrid from './components/dsGrid'
import dsTags from './components/dsTags'
import dsSectionIntro from './components/dsSectionIntro'
import dsFooter from './components/dsFooter'
import dsTagItemInline from './components/dsTagItemInline'
import dsTeamItem from './components/dsTeamItem'
import dsGridItem from './components/dsGridItem'
import Loki from 'lokijs'
// URL
const BASE_URL = '//datastudio-eindhoven.nl/proxy.php?http://141.138.193.31/~datastudio/api/wp-json/wp/v2/'
// const BASE_URL = 'https://api.datastudio-eindhoven.nl/wp-json/wp/v2/'
// CATEGORIES
const EVENT_CAT_ID = 5
const FEATURED_CAT_ID = 3
const BLOG_CAT_ID = 2
const NIEUWS_CAT_ID = 4
// PAGES
const QUOTES_ID = 697
const MEEDOEN_ID = 32
const OVERONS_ID = 696
const NIEUWS_INTRO_ID = 620
const PROGRAMMA_INTRO_ID = 26
const VERDIEPING_INTRO_ID = 623
// SUBSECTIONS
const VERDIEPING_ARCHIEF_INTRO_ID = 655
const VERDIEPING_PROGRAMMA_INTRO_ID = 632
const VERDIEPING_ESSAYS_INTRO_ID = 635
const VERDIEPING_MAPPING_INTRO_ID = 658
const VERDIEPING_KLANKBORDGROEP_INTRO_ID = 664
const VERDIEPING_LINKSNAARMEER_INTRO_ID = 661
// SUBSECTIONS: CATEGORIES
const VERDIEPING_ARCHIEF_CAT_ID = 8
const VERDIEPING_ESSAYS_CAT_ID = 14
const VERDIEPING_KLANKBORDGROEP_CAT_ID = 15

export default {
  name: 'app',
  components: {
    dsSideBar,
    dsHeader,
    dsFooter,
    dsFeatured,
    dsGrid,
    dsGridItem,
    dsTags,
    dsSectionIntro,
    dsTagItemInline,
    dsTeamItem
  },
  db: {},
  postCollection: {},
  pageCollection: {},
  categoryCollection: {},
  data() {
    return {
      filter: '',
      tagCollection: {},
      logoHidden: false,
      language: 'nl',
      about: {
        nl: '',
        en: 'english about text'
      },
      quotes: {
        en: '',
        nl: ''
      },
      currentTag: '',
      currentSearchTerm: 'yyyy',
      tags: [],
      screenSize: {
        medium: false,
        mobile: false
      },
      posts: {
        all: {},
        featured: {},
        programma: [{}],
        nieuws: {},
        related: {},
        verdieping: {},
        search: {},
        first: {},
        essays: {},
        klankbordgroep: {},
        archief: {},
        tag: {},
        single: {
          acf: {}
        }
      },
      overonsPost: {},
      meedoenPost: {},
      filters: [],
      location: {
        home: true,
        single: false,
        overons: false,
        meedoen: false,
        nieuws: false,
        programma: false,
        verdieping: false,
        zoek: false,
        tag: false,
        'verdieping-archief': false,
        'verdieping-programma': false,
        'verdieping-essays': false,
        'verdieping-mapping': false,
        'verdieping-links-naar-meer': false,
        'verdieping-klankbordgroep': false
      },
      loaded: {
        posts: false,
        pages: false,
        quotes: false,
        about: false,
        overons: false,
        meedoen: false,
        tags: false,
        tagSearch: false,
        cats: false
      },
      intro: {
        programma: {},
        verdieping: {},
        nieuws: {},
        verdiepingArchief: {},
        verdiepingProgramma: {},
        verdiepingEssays: {},
        verdiepingMapping: {},
        verdiepingLinksNaarMeer: {},
        verdiepingKlankbordgroep: {}
      }
    }
  },
  computed: {
    specialCategory() {
      if (this.posts.single.categories.indexOf(VERDIEPING_ARCHIEF_CAT_ID) > -1) {
        return {
          name: 'Archief',
          slug: 'verdieping-archief'
        }
      } else if (this.posts.single.categories.indexOf(VERDIEPING_ESSAYS_CAT_ID) > -1) {
        return {
          name: 'Essays',
          slug: 'verdieping-essays'
        }
      }
      return false
    },
    relatedPosts() {
      var relatedArticles = []
      if (this.posts.single.acf.related_articles) {
        for (let i = 0; i < this.posts.single.acf.related_articles.length; i++) {
          relatedArticles.push(
            this.postCollection.findOne({
              id: this.posts.single.acf.related_articles[i].ID
            })
          )
        }
        return relatedArticles
      } else {
        return false
      }
    }
  },
  created() {
    this.$Progress.start()
    this.db = new Loki('test.json')
    this.postCollection = this.db.addCollection('posts')
    this.pageCollection = this.db.addCollection('pages')
    this.tagCollection = this.db.addCollection('tags')
    this.categoryCollection = this.db.addCollection('category')
    this.fetchPosts(() => {
      this.setLanguage()
      if (this.$route.name) {
        if (this.$route.name === 'single') {
          // SINGLE ROUTE
          let p = this.postCollection.where(post => {
            return post.slug === this.$route.params.slug
          })
          this.posts.single = p[0]
          this.setLocation('single')
        } else if (this.$route.name === 'tag') {
          // TAG ROUTE
          this.loaded.tagSearch = false
          let tempTag = this.tagCollection.findOne({
            slug: this.$route.params.slug
          })
          this.posts.tag = this.postCollection.where(post => {
            return post.tags.indexOf(tempTag.id) > -1
          })
          this.setLocation('tag')
          this.currentTag = tempTag
          this.loaded.tagSearch = true
        } else if (this.$route.name === 'zoek') {
          this.loaded.search = false
          this.$http.get(BASE_URL + 'posts?search=' + this.$route.params.slug).then(
            response => {
              this.posts.search = response.body
              this.setLocation('zoek')
              this.loaded.search = true
            },
            response => {
              console.error(response)
            }
          )
        } else {
          // SECTION ROUTES
          this.setLocation(this.$route.name)
        }
      } else {
        this.setLocation('home')
      }
      this.loaded.posts = true
    })
    this.fetchPages(() => {
      this.loaded.about = true
      this.loaded.quotes = true
      this.loaded.meedoen = true
      this.loaded.overons = true
      this.loaded.pages = true
    })
    this.fetchTags(() => {
      this.loaded.tags = true
    })
    this.fetchCategories(() => {
      this.loaded.cats = true
    })
    this.mediaWatcher()
  },
  mounted() {
    if (window.matchMedia('(max-width: 520px)').matches) {
      this.screenSize.mobile = true
    } else {
      this.screenSize.mobile = false
    }
  },
  methods: {
    fetchPosts(cb) {
      this.$http.get(BASE_URL + 'posts?per_page=100&order=asc').then(
        response => {
          for (let i = 0; i < response.body.length; i++) {
            this.postCollection.insert(response.body[i])
          }
          this.posts.all = this.postCollection.where(post => {
            return (
              post.categories.indexOf(VERDIEPING_KLANKBORDGROEP_CAT_ID) === -1 &&
              post.categories.indexOf(VERDIEPING_ARCHIEF_CAT_ID) === -1 &&
              post.categories.indexOf(VERDIEPING_ESSAYS_CAT_ID) === -1
            )
          })
          this.posts.first = this.posts.all
          this.posts.featured = this.postCollection.where(post => {
            return post.categories.indexOf(FEATURED_CAT_ID) > -1
          })
          this.posts.programma = this.postCollection.where(post => {
            return post.categories.indexOf(EVENT_CAT_ID) > -1
          })
          this.posts.programma.sort((a, b) => {
            if (a.date < b.date) {
              return 1
            }
            if (a.date > b.date) {
              return -1
            }
            return 0
          })
          this.posts.nieuws = this.postCollection.where(post => {
            return post.categories.indexOf(NIEUWS_CAT_ID) > -1
          })
          this.posts.essays = this.postCollection.where(post => {
            return post.categories.indexOf(VERDIEPING_ESSAYS_CAT_ID) > -1
          })
          this.posts.archief = this.postCollection.where(post => {
            return post.categories.indexOf(VERDIEPING_ARCHIEF_CAT_ID) > -1
          })
          this.posts.klankbordgroep = this.postCollection.where(post => {
            return post.categories.indexOf(VERDIEPING_KLANKBORDGROEP_CAT_ID) > -1
          })
          let blog = this.postCollection.where(post => {
            return post.categories.indexOf(BLOG_CAT_ID) > -1
          })
          // this.posts.blog = blog[blog.length - 1]
          this.posts.blog = blog[0]
          cb()
        },
        response => {
          console.error(response)
        }
      )
    },
    fetchPages(cb) {
      this.$http.get(BASE_URL + 'pages?per_page=100').then(
        response => {
          for (let i = 0; i < response.body.length; i++) {
            this.pageCollection.insert(response.body[i])
          }

          // Meedoen
          this.meedoenPost = this.pageCollection.findOne({
            id: MEEDOEN_ID
          })

          // Over Ons
          this.overonsPost = this.pageCollection.findOne({
            id: OVERONS_ID
          })

          // PROGRAMMA INTRO
          this.intro.programma = this.pageCollection.findOne({
            id: PROGRAMMA_INTRO_ID
          })

          // NIEUWS
          this.intro.nieuws = this.pageCollection.findOne({
            id: NIEUWS_INTRO_ID
          })

          // VERDIEPING
          this.intro.verdieping = this.pageCollection.findOne({
            id: VERDIEPING_INTRO_ID
          })

          // VERDIEPING -- subsections
          this.intro.verdiepingArchief = this.pageCollection.findOne({
            id: VERDIEPING_ARCHIEF_INTRO_ID
          })
          this.intro.verdiepingProgramma = this.pageCollection.findOne({
            id: VERDIEPING_PROGRAMMA_INTRO_ID
          })
          this.intro.verdiepingEssays = this.pageCollection.findOne({
            id: VERDIEPING_ESSAYS_INTRO_ID
          })
          this.intro.verdiepingMapping = this.pageCollection.findOne({
            id: VERDIEPING_MAPPING_INTRO_ID
          })
          this.intro.verdiepingKlankbordgroep = this.pageCollection.findOne({
            id: VERDIEPING_KLANKBORDGROEP_INTRO_ID
          })
          this.intro.verdiepingLinksNaarMeer = this.pageCollection.findOne({
            id: VERDIEPING_LINKSNAARMEER_INTRO_ID
          })

          // QUOTES
          this.quotes = this.pageCollection.findOne({
            id: QUOTES_ID
          })

          this.posts.verdieping = this.pageCollection.where(page => {
            return page.parent === VERDIEPING_INTRO_ID
          })

          cb()
        },
        response => {
          console.error(response)
        }
      )
    },
    fetchTags(cb) {
      this.$http.get(BASE_URL + 'tags?per_page=100').then(
        response => {
          for (let i = 0; i < response.body.length; i++) {
            this.tagCollection.insert(response.body[i])
          }
          this.tags = response.body
          cb()
        },
        response => {
          console.error(response)
        }
      )
    },
    fetchCategories(cb) {
      this.$http.get(BASE_URL + 'categories?per_page=100').then(
        response => {
          for (let i = 0; i < response.body.length; i++) {
            // console.log(i)
            // console.dir(response.body[i])
            this.categoryCollection.insert(response.body[i])
          }
          this.filters = this.categoryCollection.find({
            parent: EVENT_CAT_ID
          })
          cb()
        },
        response => {
          console.error(response)
        }
      )
    },
    mediaWatcher() {
      const mq = window.matchMedia('(max-width: 520px)')
      mq.addListener(() => {
        if (mq.matches) {
          this.screenSize.mobile = true
        } else {
          this.screenSize.mobile = false
        }
      })
    },
    toggleLogo() {
      this.logoHidden = !this.logoHidden
    },
    setLocation(newLoc) {
      for (var key in this.location) {
        if (Object.prototype.hasOwnProperty.call(this.location, key)) {
          if (key === newLoc) {
            this.location[key] = true
          } else {
            this.location[key] = false
          }
        }
      }
      if (!newLoc) {
        this.location.home = true
      }
    },
    setLanguage() {
      if (this.$route.params.language === 'en') {
        this.language = 'en'
        document.getElementsByTagName('html')[0].setAttribute('lang', 'en')
      } else {
        this.language = 'nl'
        document.getElementsByTagName('html')[0].setAttribute('lang', 'nl')
      }
    }
  },
  watch: {
    $route: function() {
      //
      // SET language
      //
      this.setLanguage()
      //
      // SET ROUTES
      //
      if (!this.$route.name || this.$route.name === 'home') {
        //
        // HOME
        //
        this.setLocation('home')
      } else if (this.$route.name === 'single') {
        //
        // SINGLE
        //
        let p = this.postCollection.where(post => {
          return post.slug === this.$route.params.slug
        })
        this.posts.single = p[0]
        this.setLocation('single')
      } else if (this.$route.name === 'overons') {
        //
        // OVER ONS
        //
        this.setLocation('overons')
      } else if (this.$route.name === 'meedoen') {
        //
        // MEEDOEN
        //
        this.setLocation('meedoen')
      } else if (this.$route.name === 'programma') {
        //
        // PROGRAMMA
        //
        this.setLocation('programma')
      } else if (this.$route.name === 'nieuws') {
        //
        // NIEUWS
        //
        this.setLocation('nieuws')
      } else if (this.$route.name === 'verdieping') {
        //
        // VERDIEPING
        //
        this.setLocation('verdieping')
      } else if (this.$route.name === 'verdieping-archief') {
        //
        // VERDIEPING
        //
        this.setLocation('verdieping-archief')
      } else if (this.$route.name === 'verdieping-mapping') {
        //
        // VERDIEPING
        //
        this.setLocation('verdieping-mapping')
      } else if (this.$route.name === 'verdieping-essays') {
        //
        // VERDIEPING
        //
        this.setLocation('verdieping-essays')
      } else if (this.$route.name === 'verdieping-programma') {
        //
        // VERDIEPING
        //
        this.setLocation('verdieping-programma')
      } else if (this.$route.name === 'verdieping-links-naar-meer') {
        //
        // VERDIEPING
        //
        this.setLocation('verdieping-links-naar-meer')
      } else if (this.$route.name === 'verdieping-klankbordgroep') {
        //
        // VERDIEPING
        //
        this.setLocation('verdieping-klankbordgroep')
      } else if (this.$route.name === 'zoek') {
        //
        // ZOEK
        //
        this.loaded.search = false
        this.$http.get(BASE_URL + 'posts?search=' + this.$route.params.slug).then(
          response => {
            this.posts.search = response.body
            this.setLocation('zoek')
            this.loaded.search = true
          },
          response => {
            console.error(response)
          }
        )
      } else if (this.$route.name === 'tag') {
        //
        // TAGS
        //
        this.loaded.tagSearch = false
        let tempTag = this.tagCollection.findOne({
          slug: this.$route.params.slug
        })
        this.posts.tag = this.postCollection.where(post => {
          return post.tags.indexOf(tempTag.id) > -1
        })
        this.setLocation('tag')
        this.currentTag = tempTag
        this.loaded.tagSearch = true
      }
      document.scrollingElement.scrollTop = 0
    },
    'loaded.posts': function() {
      this.$Progress.finish()
    }
  }
}
</script>

<style lang='scss'>
@import './fonts/UniversLTCYR-75Black.css';
@import './fonts/UniversLTCYR-55Roman.css';
@import './fonts/UniversLTCYR-55Oblique.css';
@import './fonts/UniversLTCYR-45Light.css';
@import './styles/helpers/_reset.scss';
@import './styles/helpers/_mixins.scss';
@import './styles/responsive/_manager.scss';
@import './styles/responsive/_embed.scss';
@import './styles/_variables.scss';
@import './styles/_space.scss';
@import './styles/_color.scss';
@import './styles/_base_elements.scss';
@import './styles/_typography.scss';
* {
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility !important;
}
body {
  background: $background-color;
  color: $main-color;
  line-height: 2 * $baseline;
  font-family: 'UniversLTCYR-45Light', helvetica, arial, sans-serif;
  margin: $baseline * 2 $margin $margin;
}
#app {
  display: inline-block;
  width: 1186px;
  min-height: 110vh;
  @include screen-size ('medium') {
    width: 950px;
  }
  @include screen-size ('x-small') {
    width: 100%;
  }
}
#container {
  width: 1012px;
  float: left;
  @include screen-size ('medium') {
    width: 670px;
  }
  @include screen-size ('x-small') {
    width: 100%;
    margin-top: $baseline;
  }
}
main {
  min-height: 118 * $baseline;
  @include screen-size ('x-small') {
    overflow: hidden;
    min-height: none;
  }
}
.main-column {
  float: left;
  width: 2 * $column + $margin;
  margin-right: $margin;
  @include screen-size ('x-small') {
    width: 670px;
  }
  @include screen-size ('x-small') {
    width: 100%;
  }
}
.secondary-column {
  float: left;
  width: $column;
  margin: 0;
  @include screen-size ('medium') {
    display: none;
  }
}
.sidebar-column {
  @include screen-size ('x-small') {
    display: none;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#pop-up {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  cursor: pointer;
  opacity: 1;
  img {
    @include center;
    position: fixed;
    max-height: 70%;
    max-width: 70%;
    @include screen-size ('x-small') {
      max-height: 90%;
      max-width: 90%;
    }
  }
  &.hidden {
    opacity: 0.449;
    pointer-events: none;
    transition: all 0.4s ease-out;
    transform: rotateX(90deg);
  }
}
.float-left {
  float: left;
}
.aside-tags,
.team-container {
  height: 44 * $baseline;
}
.top-block {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 6 * $baseline;
  background: $background-color;
  z-index: 100;
  display: none;
  @include screen-size ('x-small') {
    display: block;
  }
}
form {
  position: relative;
  top: 1px;
  p {
    margin-bottom: 0;
  }
  input[type='email'],
  input[type='text'] {
    position: relative;
    top: 3px;
    //    background: red;
    outline: none;
    border: 0;
    margin-bottom: $baseline;
    border: 1px solid $secondary-color;
    height: 3 * $baseline;
    width: 100%;
    font-size: $small-text;
    padding-left: 0.5em;
  }
  input[type='submit'] {
    top: 3px;
    position: relative;
    border: 1px solid $secondary-color;
    margin-bottom: $baseline * 2;
    height: 3 * $baseline;
    line-height: 2 * $baseline;
    background: $secondary-color;
    color: $background-color;
    font-size: $small-text !important;
    width: 100%;
    &:hover {
      background: $high-light;
      border: 1px solid $high-light;
      cursor: pointer;
    }
  }
  .screen-reader-response {
    display: none;
  }
  span[role='alert'] {
    font-size: $x-small-text;
    color: red;
    margin-top: $baseline;
    display: block;
  }
  .wpcf7-validation-errors {
    border: none !important;
    line-height: 3 * $baseline;
    height: 3 * $baseline;
    color: red;
  }
}

.one-column-fixed-height {
  height: 44 * $baseline;
  position: relative;
  float: left;
  width: 2 * $column + $margin;
  margin-right: $margin;
  @include screen-size ('x-small') {
    width: 670px;
  }
  @include screen-size ('x-small') {
    width: 100%;
  }
  img {
    height: 24 * $baseline !important;
  }
}
.press {
  display: block;
  border: none;
  &:hover {
    color: $high-light;
    cursor: pointer;
    border: none;
  }
}
.no-underline {
  border: none;
  &:hover {
    border: none;
  }
}
.focus-group {
  &:hover {
    .description {
      color: $main-color !important;
    }
    .image-container {
      img {
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?608f73a2